import imguser from '../../../../assets/images/user.png'
import moment from 'moment';
import Switch from "react-switch";

export const ColumnUser = (translate, warning, handleEdit, editStatus,langLocal) => {
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,width: "50px",
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,width: "260px",
            cell: (row) => (
                <div className='div_img_table' >
                    <img className={langLocal === 'ar' ? "margin_left_10": "margin_right_10"} src={imguser} />
                    <span>{row['name']}</span>
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('email')}</span>, sortable: true,width: "300px",
            cell: (row) => (
                <span>{row['email']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('role')}</span>, width: "220px",width: "150px",
            cell: (row) => (
                <span>{row['role']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,width: "170px",
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('activation')}</span>,width: "100px",
            cell: (row) => (
                <div className='div_switch'>
                    <SwitchComponent checked={row.status} onChange={() => editStatus(row.id, row.status)} />
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row) => (
                <div>
                    <i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>
                </div>
            )
        }
    ]
    return {
        columns
    }
}
function SwitchComponent({ checked, onChange }) {
    return (
        <Switch
            onColor='#756bc1'
            checkedIcon={false}
            uncheckedIcon={false}
            height={20}
            width={40}
            handleDiameter={15}
            checked={checked}
            onChange={onChange}
        />
    );
}
{/*<OptionsIcon warning={warning} row={row} setopenEdit={setopenEdit} handleEdit={handleEdit} />*/ }